export default function AboutSection() {
  const schools = [
    {
      name: '恒德職業学校',
      description: '専門技術と実践的なスキルを重視した職業学校。多様な分野の専門知識を提供し、学生が即戦力として活躍できるよう育成します。',
      icon: 'ri-tools-line'
    },
    {
      name: '明德職業学校',
      description: '理論と実践をバランスよく学べる環境を提供。各業界の最新の知識と技術を取り入れたカリキュラムを用意しています。',
      icon: 'ri-book-open-line'
    },
    {
      name: '東京こころ日本語学校',
      description: '日本語教育に特化した学校。留学生が日本での生活と学業にスムーズに適応できるようサポート。JLPT対策や文化体験プログラムも充実。',
      icon: 'ri-translate-2'
    }
  ];

  return (
    <section id="about" className="py-24 bg-amber-100/40">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-20">
          <div>
            <p className="text-xs text-gray-500 mb-6">/ About Us</p>
            <h2 className="text-4xl font-light mb-8" style={{ fontFamily: 'serif' }}>会社概要</h2>
            <div className="space-y-6">
              <div className="bg-white/60 rounded-xl p-6">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div className="text-gray-500">会社名</div>
                  <div className="text-amber-900 font-medium">虹橋株式会社</div>
                  
                  <div className="text-gray-500">設立</div>
                  <div className="text-amber-900">2019年</div>
                  
                  <div className="text-gray-500">所在地</div>
                  <div className="text-amber-900">東京都新宿大久保2-13-4 303</div>
                  
                  <div className="text-gray-500">代表者</div>
                  <div className="text-amber-900">単 棟煒</div>
                  
                  <div className="text-gray-500">連絡先</div>
                  <div className="text-amber-900">kosugi@nijihashi.co.jp</div>
                </div>
              </div>

              {/* 不動産資格 */}
              <div className="bg-white/60 rounded-xl p-6">
                <div className="flex items-center space-x-2 mb-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-award-line text-amber-700 text-lg"></i>
                  </div>
                  <h4 className="font-medium text-amber-900 text-sm">不動産資格・免許</h4>
                </div>
                <div className="grid grid-cols-2 gap-4 text-sm mb-5">
                  <div className="text-gray-500">免許種別</div>
                  <div className="text-amber-900 font-medium">宅地建物取引業者免許</div>
                  
                  <div className="text-gray-500">免許番号</div>
                  <div className="text-amber-900">東京都知事（1）第108074号</div>
                  
                  <div className="text-gray-500">有効期間</div>
                  <div className="text-amber-900">令和4年7月16日〜令和9年7月15日</div>
                </div>
                {/* 免許証画像 */}
                <div className="relative group cursor-pointer" onClick={() => window.open('https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/561eb61f9cdb1f4de1b8a2950e2b103f.jpeg', '_blank')}>
                  <div className="w-full h-48 rounded-lg overflow-hidden border border-amber-200 shadow-sm">
                    <img
                      src="https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/561eb61f9cdb1f4de1b8a2950e2b103f.jpeg"
                      alt="宅地建物取引業者免許証"
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 rounded-lg flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/90 rounded-full px-3 py-1 text-xs text-amber-900 flex items-center space-x-1">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-zoom-in-line text-sm"></i>
                      </div>
                      <span>拡大表示</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-light mb-6" style={{ fontFamily: 'serif' }}>企業理念</h3>
            <p className="text-xl font-light leading-relaxed text-amber-900 mb-8" style={{ fontFamily: 'serif' }}>
              「学生一人ひとりの未来を虹のように輝かせる」
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              私たち虹橋株式会社は、学生の夢や目標を実現するために、全力でサポートすることをお約束します。
            </p>
            <div className="bg-teal-600/10 rounded-xl p-6 border border-teal-600/20">
              <div className="flex items-center space-x-3 mb-3">
                <i className="ri-home-heart-fill text-teal-600 text-2xl"></i>
                <h4 className="font-medium text-amber-900">寮管理実績</h4>
              </div>
              <p className="text-2xl font-bold text-teal-600 mb-1">50名以上</p>
              <p className="text-sm text-gray-600">の学生が弊社管理の学生宿舎を利用</p>
            </div>
          </div>
        </div>

        <div className="mb-20">
          <h3 className="text-3xl font-light mb-12 text-center" style={{ fontFamily: 'serif' }}>
            グループ内教育機関
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {schools.map((school, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-8 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-14 h-14 bg-teal-600/10 rounded-full flex items-center justify-center mb-6">
                  <i className={`${school.icon} text-teal-600 text-2xl`}></i>
                </div>
                <h4 className="text-xl font-medium mb-4 text-amber-900">{school.name}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{school.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-light mb-12 text-center" style={{ fontFamily: 'serif' }}>
            支援成功事例
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/80 rounded-xl p-6 border-l-4 border-teal-600">
              <div className="flex items-center space-x-2 mb-3">
                <i className="ri-line-chart-line text-teal-600 text-xl"></i>
                <h4 className="font-medium text-amber-900">事例 1</h4>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                学業成績が低迷していた学生が、弊社の個別学習サポートを受け、成績が向上し、無事に卒業しました。
              </p>
            </div>
            
            <div className="bg-white/80 rounded-xl p-6 border-l-4 border-teal-600">
              <div className="flex items-center space-x-2 mb-3">
                <i className="ri-home-smile-line text-teal-600 text-xl"></i>
                <h4 className="font-medium text-amber-900">事例 2</h4>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                初めての一人暮らしに不安を感じていた学生が、宿舎管理サービスの利用により安心して生活を送ることができました。
              </p>
            </div>
            
            <div className="bg-white/80 rounded-xl p-6 border-l-4 border-teal-600">
              <div className="flex items-center space-x-2 mb-3">
                <i className="ri-briefcase-line text-teal-600 text-xl"></i>
                <h4 className="font-medium text-amber-900">事例 3</h4>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                キャリアカウンセリングを受けた学生が、自分の適性に合った企業への就職に成功しました。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}